import React from 'react';
const BONUS_IMAGES = {
  bonus1: 'https://cdn.magicpatterns.com/uploads/tf88wDgoDF6NNZQtYUgyFi/Cover_bono_1.png',
  bonus2: 'https://cdn.magicpatterns.com/uploads/rJ1xEQrL7NFkG88H9CLg2t/Cover_bono_2.png',
  bonus3: 'https://cdn.magicpatterns.com/uploads/f9A5d1n9ezK97371uBRHgt/Cover_bono_3.png',
  bonus4: 'https://cdn.magicpatterns.com/uploads/xoDVaJ4WX89ifLyWSKdKVK/Cover_bono_4.png'
};
const BONUSES = [{
  title: 'BONO 1: Qué Decir Cuando Te Quedas en Blanco',
  description: '50 frases de salida para iniciar natural, sostener la charla y evitar silencios incómodos.',
  image: BONUS_IMAGES.bonus1,
  value: '$27'
}, {
  title: 'BONO 2: Señales de Interés Femenino',
  description: 'Confirmá si tenés su atención. ¿Educada o atraída? Aprende a leer las señales.',
  image: BONUS_IMAGES.bonus2,
  value: '$19'
}, {
  title: 'BONO 3: Plantillas de Mensajes que Mantienen Interés',
  description: 'Primer mensaje, cómo invitar a salir sin presión, evitar ser ignorado.',
  image: BONUS_IMAGES.bonus3,
  value: '$15'
}, {
  title: 'BONO 4: Mentalidad Anti-Rechazo',
  description: 'NO te tomes el rechazo personal. Recuperá seguridad en minutos. Tu valor NO depende del resultado.',
  image: BONUS_IMAGES.bonus4,
  value: '$35'
}];
export function BonusSection() {
  const scrollToPurchase = () => {
    document.getElementById('purchase')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-20 px-4 bg-gradient-to-b from-slate-900 to-slate-950" data-id="element-27">
      <div className="max-w-6xl mx-auto" data-id="element-28">
        <div className="text-center mb-16" data-id="element-29">
          <div className="inline-block px-4 py-1 rounded-full bg-[#E63946]/20 text-[#E63946] font-bold mb-4 border border-[#E63946]/30 animate-pulse" data-id="element-30">
            🎁 SOLO POR HOY
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-31">
            4 Regalos Exclusivos <span className="text-[#E63946]" data-id="element-32">GRATIS</span>
          </h2>
          <p className="text-xl text-slate-400" data-id="element-33">
            Al ordenar hoy, te llevas todo esto sin costo adicional.
          </p>
          <p className="text-2xl font-bold text-green-400 mt-4" data-id="element-34">
            Valor total: $96 → <span className="text-white" data-id="element-35">GRATIS</span>
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-36">
          {BONUSES.map((bonus, index) => <div key={index} onClick={scrollToPurchase} className="bg-slate-800/30 rounded-2xl p-6 border border-slate-700/50 flex flex-col md:flex-row gap-6 items-center relative overflow-hidden cursor-pointer group hover:bg-slate-800/50 hover:border-purple-500/30 transition-all duration-300 hover:-translate-y-1" data-id="element-37">
              {/* GRATIS Badge */}
              <div className="absolute top-4 right-4 bg-gradient-to-r from-[#E63946] to-[#ff4757] text-white text-xs font-bold px-3 py-1.5 rounded-full shadow-lg z-10 animate-pulse" data-id="element-38">
                🎁 GRATIS HOY
              </div>

              {/* Bonus Image */}
              <div className="shrink-0 w-40 md:w-48 relative" data-id="element-39">
                <img src={bonus.image} alt={bonus.title} className="w-full h-auto rounded-lg shadow-xl transform group-hover:scale-105 transition-transform duration-300" data-id="element-40" />
                {/* Glow effect */}
                <div className="absolute -inset-2 bg-gradient-to-r from-red-500/20 to-orange-500/20 rounded-xl blur-xl -z-10 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-41"></div>
              </div>

              {/* Bonus Info */}
              <div className="flex-1 text-center md:text-left" data-id="element-42">
                <h3 className="text-xl font-bold text-white mb-3 pr-0 md:pr-16" data-id="element-43">
                  {bonus.title}
                </h3>
                <p className="text-slate-400 mb-4 text-sm leading-relaxed" data-id="element-44">
                  {bonus.description}
                </p>
                <div className="flex items-center justify-center md:justify-start gap-3" data-id="element-45">
                  <span className="text-slate-500 line-through text-sm" data-id="element-46">
                    Valor: {bonus.value}
                  </span>
                  <span className="text-green-400 font-bold" data-id="element-47">→ GRATIS</span>
                </div>
              </div>
            </div>)}
        </div>

        {/* Total Value Summary */}
        <div className="mt-12 text-center p-6 bg-gradient-to-r from-slate-800/50 via-purple-900/20 to-slate-800/50 rounded-2xl border border-purple-500/20" data-id="element-48">
          <p className="text-lg text-slate-300" data-id="element-49">
            Valor total de los bonos:{' '}
            <span className="line-through text-slate-500" data-id="element-50">$96</span>
          </p>
          <p className="text-2xl font-bold text-white mt-2" data-id="element-51">
            Hoy te los llevas{' '}
            <span className="text-green-400" data-id="element-52">100% GRATIS</span> con tu compra
          </p>
        </div>
      </div>
    </section>;
}